import { render, staticRenderFns } from "./RafflePrizesComponentView.vue?vue&type=template&id=28825534&scoped=true"
import script from "./RafflePrizesComponentView.vue?vue&type=script&lang=js"
export * from "./RafflePrizesComponentView.vue?vue&type=script&lang=js"
import style0 from "./RafflePrizesComponentView.vue?vue&type=style&index=0&id=28825534&prod&scoped=true&lang=css"
import style1 from "./RafflePrizesComponentView.vue?vue&type=style&index=1&id=28825534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28825534",
  null
  
)

export default component.exports